import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  ActivityIndicator,
  Picker,
  Platform,
} from "react-native";
import {
  Flex,
  Padding,
  Margin,
  Helpers,
  Typo,
  article,
  button,
  articleItem,
  FontFamily,
  articleLists,
  FontWeight,
  appHeader,
} from "../../styles/appStyles";
import TouchableOpacityLink from "../touchable-opacity-link";
import ArticleTopStories from "../article-item-vertical/index-top-stories";
import ScrollContainerView from "../scroll-container-view";
import { helpers } from "../../utils/helpers";
import getImagePath from "../../utils/image-helper";
import CustomImage from "../custom-image";
import { Mixpanel } from "../../utils/mixpanel";

const viewMore = getImagePath("icons/arrow-right-orange.png");

export class HomeTrendingStories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSlug: "all",
      data: [],
    };
  }

  componentDidMount = () => {
    let { data } = this.props;
    console.log('dataNew', data);
    let allPosts = [];
    let businessPosts = [];
    let internetPosts = [];
    let chaosPosts = [];
    data.forEach((element, index) => {
      if (element.category.slug === 'business') {
        businessPosts.push(element)
      }
      if (element.category.slug === 'internet') {
        internetPosts.push(element)
      }
      if (element.category.slug === 'chaos') {
        chaosPosts.push(element)
      }
      if (index === 0 || index === 3 || index === 6 || index === 8) {
        allPosts.push(element);
      }
    });
    this.setState({ data: [{ name: 'All', slug: 'all', posts: allPosts }, { name: 'Business', slug: 'business', posts: businessPosts }, { name: 'Internet', slug: 'internet', posts: internetPosts }, { name: 'Chaos', slug: 'chaos', posts: chaosPosts }] });
  };

  viewArticle = (catSlug, slug, postData) => {
    const { viewArticle } = this.props;
    viewArticle(catSlug, slug, postData);
  };

  viewAuthor = (slug) => {
    const { viewAuthor } = this.props;
    viewAuthor(slug);
  };

  handleClick = (title, data, index) => {
    try {
      if (this.props.trackStoryClick) {
        this.props.trackStoryClick(title, data, index);
      }
    } catch (error) {
      console.log("check mix panel track error ==>", error);
    }
  };

  trackViewCategory = (data) => {
    // try {
    //     Mixpanel.track('click_view_all', {cateory : data.slug});
    // }
    // catch(error) {
    //     console.log("check mix panel track error ==>", error);
    // }

    if (helpers.isWeb()) {
      viewAllBtnProps = {
        to: "/category/" + data.slug + "/all",
      };
    } else {
      viewAllBtnProps = {
        onPress: () => this.props.viewAllInCategory(data.slug),
      };
    }
    return viewAllBtnProps;
  };

  setSlug = (slug) => {
    this.setState({ selectedSlug: slug });
  };

  render() {
    const { darkMode, freeUser } = this.props;
    const { data } = this.state;
    let allPosts = [];

    let { selectedSlug } = this.state;
    let btnClick;
    if (helpers.isWeb()) {
      btnClick = {
        to: "/all-stories",
      };
    } else {
      btnClick = {
        onPress: () => this.viewMoreArticles(),
      };
    }
    let viewAllBtn;
    if (helpers.isWeb()) {
      viewAllBtn = {
        to: '/all-stories'
      }
    } else {
      viewAllBtn = {
        onPress: () => this.props.navigateApp('/all-stories')
      }
    }
    let viewAllBtnProps;
    if (helpers.isWeb()) {
      viewAllBtnProps = {
        to: "/category/" + data.slug + "/all",
      };
    } else {
      viewAllBtnProps = {
        onPress: () => this.props.viewAllInCategory(data.slug),
      };
    }

    return (
      <View style={!darkMode && { backgroundColor: !helpers.isDesktop() ? "#F3F5FF" : "#F3F5FF", marginTop: !helpers.isDesktop() ? "-25px" : 0 }}>
        <View
          style={[
            Padding.ph_2,
            Helpers.conatinerWeb,
            helpers.isDesktop() && Helpers.conatinerWebFull,
            helpers.isDesktop() && { marginBottom: 10, marginTop: 30 },
            !helpers.isDesktop() && { marginBottom: 40, marginTop: 48, alignItems: "center", paddingLeft: 0, paddingRight: 0 },
          ]}
        >
          {!helpers.isDesktop() && (
            <View style={[appHeader.trendingWrapper, { alignItems: "center" }]}>
              <Text
                style={[
                  { fontFamily: FontFamily.abrilFatface },
                  {
                    fontSize: helpers.isDesktop() ? 30 : 34,
                    color: "#051462",
                    fontWeight: "400",
                  },
                  { width: helpers.isWeb() ? "fit-content" : "100%" },
                  { paddingBottom: helpers.isWeb() ? 24 : 0 },
                  darkMode && { color: "rgba(255,255,255,0.87)" },
                ]}
              >
                Top Stories
              </Text>
            </View>
          )}
          <View style={{ flexDirection: "row", marginBottom: helpers.isDesktop() ? 30 : 0 }}>
            {helpers.isDesktop() && (
              <View style={[appHeader.trendingWrapper]}>
                <Text
                  style={[
                    { fontFamily: FontFamily.abrilFatface },
                    { fontSize: helpers.isDesktop() ? 30 : 34, paddingBottom: '24', color: "#051462", fontWeight: "400" },
                    { width: helpers.isWeb() ? "fit-content" : "100%" },
                    { paddingBottom: helpers.isWeb() ? 0 : 0 },
                    darkMode && { color: "rgba(255,255,255,0.87)" },
                  ]}
                >
                  Top Stories
                </Text>
              </View>
            )}
            {data &&
              data.map((item, index) => {
                return (
                  <View style={[appHeader.trendingWrapper, { marginBottom: helpers.isDesktop() ? 0 : 20 }]}>
                    <TouchableOpacityLink
                      //   {...viewAllBtnProps}
                      handleClick={() => {
                        this.setSlug(item.slug);
                      }}
                    >
                      <Text
                        style={[
                          { fontFamily: FontFamily.abrilFatface },
                          {
                            fontSize: helpers.isDesktop() ? 20 : 20,
                            fontWeight: "400",
                            lineHeight: '24px'
                          },
                          {
                            color:
                              selectedSlug == item.slug ? "#6C7AF6" : "#000",
                            borderBottomWidth:
                              selectedSlug == item.slug ? 2 : 0,
                            borderBottomColor:
                              selectedSlug == item.slug ? "#6C7AF6" : "#000",
                          },
                          { width: helpers.isWeb() ? "fit-content" : "100%" },
                          darkMode && { color: "rgba(255,255,255,0.87)" },
                        ]}
                      >
                        {item.name}{" "}
                      </Text>
                    </TouchableOpacityLink>
                  </View>
                );
              })}
            {helpers.isDesktop() && (
              <View style={[appHeader.trendingWrapper, { marginLeft: "auto" }]}>
                <TouchableOpacityLink
                  {...viewAllBtn}
                >
                  <Text
                    style={[
                      Helpers.textUppercase,
                      {
                        color: "#907CFF",
                        fontSize: 18,
                        fontFamily: FontFamily.medium,
                        fontWeight: FontWeight.semiBold,
                        whiteSpace: "nowrap",
                        borderWidth: 1,
                        borderColor: "#907CFF",
                        paddingHorizontal: 20,
                        paddingVertical: 10,
                      },
                    ]}
                  >
                    VIEW ALL STORIES
                  </Text>
                </TouchableOpacityLink>
              </View>
            )}
          </View>
          {data &&
            data.map((data, indexMain) => {
              if (data.slug === selectedSlug) {
                return (
                  <View style={[{ width: !helpers.isDesktop() ? '100%' : 'auto' }]}>
                    <View style={[Margin.mt_2, Margin.mb_15]}>
                      {helpers.isDesktop() ? (
                        <View style={[Flex.row, Flex.FlexWrap]}>
                          {data &&
                            data.posts &&
                            data.posts.map((item, index) => {
                              return (
                                <View>
                                  <ArticleTopStories
                                    viewArticle={(catSlug, slug, postData) =>
                                      this.viewArticle(catSlug, slug, postData)
                                    }
                                    viewAuthor={(slug) => this.viewAuthor(slug)}
                                    data={item}
                                    single={index === 0 ? true : false}
                                    freeUser={freeUser}
                                    all={
                                      selectedSlug === "all" &&
                                        indexMain === 0 &&
                                        index === 0
                                        ? true
                                        : false
                                    }
                                    // mainIndex={indexMain === 0 ? true : false}
                                    home={true}
                                    hometrendingstory={true}
                                    handleClick={(title) => {
                                      this.handleClick(title, item, index);
                                    }}
                                    hideDate={false}
                                    darkMode={darkMode}
                                  />
                                </View>
                              );
                            })}
                        </View>
                      ) : (
                        <View style={[Flex.column]}>
                          {data &&
                            data.posts &&
                            data.posts.map((item, index) => {
                              return (
                                <View style={[articleItem.col6]}>
                                  <ArticleTopStories
                                    viewArticle={(catSlug, slug, postData) =>
                                      this.viewArticle(catSlug, slug, postData)
                                    }
                                    viewAuthor={(slug) => this.viewAuthor(slug)}
                                    data={item}
                                    freeUser={freeUser}
                                    single={index === 0 ? true : false}
                                    mainIndex={indexMain === 0 ? true : false}
                                    home={true}
                                    handleClick={(title) => {
                                      this.handleClick(title, item, index);
                                    }}
                                    hideDate={false}
                                    darkMode={darkMode}
                                  />
                                </View>
                              );
                            })}
                        </View>
                      )}
                    </View>
                  </View>
                );
              }
            })}
          {!helpers.isDesktop() && (
            <View style={[appHeader.trendingWrapper]}>
              <TouchableOpacityLink {...btnClick}>
                <Text
                  style={[
                    Helpers.textUppercase,
                    {
                      color: "#907CFF",
                      fontSize: 18,
                      fontFamily: FontFamily.medium,
                      fontWeight: FontWeight.semiBold,
                      whiteSpace: "nowrap",
                      borderWidth: 1,
                      borderColor: "#907CFF",
                      paddingHorizontal: 20,
                      paddingVertical: 10,
                    },
                  ]}
                >
                  VIEW ALL STORIES
                </Text>
              </TouchableOpacityLink>
            </View>
          )}
        </View>
      </View >
    );
  }
}

export default HomeTrendingStories;
